function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}


function getFormattedAcctString(accountString) {
    const delimiter = window.server_settings.platform_delimiter;
    const suffixes = window.server_settings.platform_suffixes;
    for (let i in suffixes) {
        const suffix = accountString.substring(accountString.length - 2, accountString.length).toLowerCase();
        if (suffix === delimiter + suffixes[i]) {
            return accountString.substring(0, accountString.length - 2);
        }
    }
    return accountString;
}

function updateCommonMenuData(accountInfo) {

    var userid = accountInfo.get_spa_id(),
        username = accountInfo.get_nickname();

    if (userid && username) {
        WG.CommonMenu.update({
            user_id: userid,
            user_name: getFormattedAcctString(username),
        });
    }
}

function commonMenuAvailable() {
    return window.WG && window.WG.CommonMenu;
}

var onMenuLogout = function(event, data) {
    var returnTo = window.location.href;
    window.Application.trigger('authenticationoid:logout', returnTo);
    event.preventDefault();
};

function inject_facebook_script_node(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/" + window.server_settings.facebook_locale + "/sdk.js#xfbml=1&version=v2.0";
    fjs.parentNode.insertBefore(js, fjs);
}

function detect_unused_browser(){
    var unsupportedBrowsersUserAgentsRe = window.server_settings.unsupported_browsers_pattern;
    var usedUnsupportedBrowser = Cookies.get(window.server_settings.cookie_name_use_unsupported_browsers);
    var i;

    var update_browser_url = window.server_settings.urls.update_browser;
    if (!usedUnsupportedBrowser) {
        for (i=0; i < unsupportedBrowsersUserAgentsRe.length; i++) {
            if (unsupportedBrowsersUserAgentsRe[i].exec(navigator.userAgent)) {
                try{
                    $('<a></a>')
                            .attr('href', update_browser_url)
                            .prependTo('body')
                            .get(0)
                            .click();
                }catch(ex){
                    window.location = update_browser_url;
                }
            }
        }
    }
}

function modify_language_switchers(){
    let language_switchers = document.getElementsByClassName('language-div');
    language_switchers[0].classList.add("lang-nav");
    language_switchers[1].classList.add("lang-footer"); 
}

function add_commonmenu(wgsdk){
    var accountInfo = wgsdk.account_info();

    accountInfo.set_commonmenu_cookies();

    WG = window.WG || {};
    WG.CommonMenuCallbacks = WG.CommonMenuCallbacks || {};

    WG.CommonMenuCallbacks.beforeInit = function() {
        if (accountInfo.has_data()) {
            updateCommonMenuData(accountInfo);
        } else {
            accountInfo.update_cookie_from_server(updateCommonMenuData)
        }
    };

    if (window.WG && WG.CommonMenu) {
        WG.CommonMenu.trigger('holder_ready');
    }


    window.Application.bind('menu-logout', onMenuLogout);
}

function install_mobile_dropdown_menus(){
    var $menu_open = $('.menu-open');
    var $menu_close = $('.menu-close');
    var $body = $('body');
    var $main_header = $('#main-header');
    var $nav_item = $('.nav-item');

    $menu_open.on('click', function(e){
        $body.addClass('fixed');
        $main_header.addClass(['open-menu', 'hide']);
    });
    $menu_close.on('click', function(e){
        $body.removeClass('fixed');
        $main_header.removeClass(['open-menu', 'hide']);
    });
    $nav_item.on('click', function(e){
        var $target = $(e.currentTarget);
        if ($target.hasClass('open')){
            $target.removeClass('open')
            $target.find('.submenu').css({'display': 'none'});
        } else {
            $target.addClass('open')
            $target.find('.submenu').css({'display': 'block'});
        }
    });
}

export function bindCommonMenuEvents() {
    if (!commonMenuAvailable()) {
        console.log('Common menu unavailable.  This is a bug');
        return;
    }
    window.WG.CommonMenu.on('logout', function(event, wgcm) {
        window.Application.trigger('menu-logout', event, {
            wgcm: wgcm
        });
    });
}


export function injectSVGs(){
    SVGInjector(document.querySelectorAll('.js-svg-icon'), {each: SVGAutoResize});
}


export function portal_base_onload_handler(csrf_token, wgsdk){
    var $html = $('html');
    $html.attr('data-user-agent', navigator.userAgent);
    if (navigator.userAgent.match('Tablet PC'))
        $html.addClass('touchevents').removeClass('no-touchevents');
    
    $.ajaxSetup({
        beforeSend: function(xhr, settings) {
            if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
                xhr.setRequestHeader("X-CSRFToken", csrf_token);
            }
        }
    });

    add_commonmenu(wgsdk);
    detect_unused_browser()
    inject_facebook_script_node(document, 'script', 'facebook-jssdk');
    modify_language_switchers();
    injectSVGs();
    install_mobile_dropdown_menus();
}
